import { render, staticRenderFns } from "./FulfillmentOrder.vue?vue&type=template&id=5f4eddfb&"
import script from "./FulfillmentOrder.vue?vue&type=script&lang=js&"
export * from "./FulfillmentOrder.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports